import React from 'react';
import PropTypes from 'prop-types';
import styles from "./LoginButton.module.css";

const LoginButton = ({onBtnClick}) => {

return (
    <>
        <div className={styles.LoginButtonContainer}>
            <button className={styles.LoginButton} onClick={onBtnClick}>Login</button>
        </div>
    </>
);
};

LoginButton.propTypes={
    onBtnClick: PropTypes.func.isRequired,
}

export default LoginButton